import React, {
	memo, useEffect
}from 'react'
import {
	Select, Tag
}from 'antd'
import {
	useDispatch, useSelector
}from 'react-redux'
import { managementActions } from '../../../../../../Management/store/actions'
import 'antd/lib/tag/style/index.css'
import 'antd/lib/tooltip/style/index.css'
import '../style.css'
import {
	CustomSelect
}from '../../../../../../../components/CustomSelect'

const {
	Option
} = Select

const ResolutionResponsibleManagerSelect = memo(({userToHideId, ...props}) => {
	const dispatch = useDispatch()
	const {listResponsibleManagers, listResponsibleManagersLoading} = useSelector((state) =>  state.managementReducer)

	useEffect(() => {
		dispatch(managementActions.getResponsibleManagersForResolution())
		return () => {
			dispatch(managementActions.clearResponsibleManagersForResolution())
		}
	}, [])

	const getOptions = () => {
		return (
			listResponsibleManagers.map((responsibleManager) => {
				if(userToHideId !== responsibleManager.id)
				return (
					<Option
						key={ responsibleManager.id }
						className="icon_executor_selector"
						value={ responsibleManager.id }
					>
						<span>
							<Tag>
								{ responsibleManager.position }
							</Tag>
							<span>
								{ ` - ${ responsibleManager.fullName }` }
							</span>
						</span>
					</Option>
				)
			})
		)
	}

	return (
		<span id = 'executorItem'>
		<CustomSelect
			{ ...props }
			allowClear
			showSearch
			defaultActiveFirstOption={ false }
			filterOption={ (input, option) => {
				return option.children.props.children[1]?.props.children.toLowerCase().includes(input.toLowerCase())
			} }
			className="executor_selector"
			loading={ listResponsibleManagersLoading }
		>
			{
				listResponsibleManagers?.length > 0 && getOptions()
			}
		</CustomSelect>
		</span>
	)
})
export default ResolutionResponsibleManagerSelect